import React, { FC, useRef, useState } from 'react';
import DocUploadDropbox, { UploadDropboxRef } from './DocUploadDropbox';
import LargePlusIcon from '../../../../images/components/LargePlusIcon';
import { classes, stylesheet } from 'typestyle';
import { Blue10, Blue80, Gray10, Gray100, Gray50, typeCompact12Medium, typeCompact14Medium } from '@traceair/tds';

const MAX_FILES_SIZE = 50e6; // 50 Mb

type DocDropboxProps = {
  onDrop: (files: File[]) => void;
};

const DocDropbox: FC<DocDropboxProps> = ({ onDrop }) => {
  const uploadDropboxRef = useRef<UploadDropboxRef>(null);
  const [isDragOver, setIsDragOver] = useState(false);

  function handleDrop(files: File[]) {
    setIsDragOver(false);
    onDrop(files);
  }

  function handleSelectFilesClick() {
    uploadDropboxRef.current?.open();
  }

  return (
    <DocUploadDropbox
      label={''}
      noClick={true}
      multiple={true}
      ref={uploadDropboxRef}
      onDrop={handleDrop}
      className={classes(css.root, isDragOver ? css.dragOver : css.normal)}
      maxSize={MAX_FILES_SIZE}
      onDragEnter={() => setIsDragOver(true)}
      onDragLeave={() => setIsDragOver(false)}
    >
      <LargePlusIcon color={isDragOver ? Blue80 : Gray100} />
      <div className={typeCompact14Medium} style={{ marginTop: 8 }}>
        <span>Drop files here, or </span>
        <span style={{ color: Blue80, cursor: 'pointer' }} onClick={handleSelectFilesClick}>
          click to browse
        </span>
      </div>
      <div className={typeCompact12Medium} style={{ color: Gray100, marginTop: 6 }}>
        Preferable formats: PDF, JPG, PNG
      </div>
      <div className={typeCompact12Medium} style={{ color: Gray100 }}>
        Max 50 Mb
      </div>
    </DocUploadDropbox>
  );
};

const css = stylesheet({
  root: {
    marginTop: 16,
    height: 220,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 9,
    borderWidth: 2,
  },
  normal: {
    backgroundColor: Gray10,
    borderColor: Gray50,
    borderStyle: 'dashed',
  },
  dragOver: {
    backgroundColor: Blue10,
    borderColor: Blue80,
    borderStyle: 'solid',
  },
});

export default DocDropbox;
